import { createContext, useContext } from 'react';
import type { ComposerCommand } from '@/lib/desktop-shell/composer-commands';

/** Runs the composer's commands for the conversation it writes to (its pane provides it). */
export type ComposerCommandRunner = {
  /** Whether the command can act here (Review needs a repository, rewind a message). */
  available: (id: ComposerCommand['id']) => boolean;
  run: (id: ComposerCommand['id']) => void;
};

const ComposerCommandsContext = createContext<ComposerCommandRunner | null>(null);

export const ComposerCommandsProvider = ComposerCommandsContext.Provider;

/** The runner of the composer's commands, `null` where nothing runs them (an embedded chat). */
export function useComposerCommands(): ComposerCommandRunner | null {
  return useContext(ComposerCommandsContext);
}
